import { getFlexSelectCustomStyle } from '../../../../assets/styles/multiple_select';
import { AddProductModalContent } from './components/AddProductModalContent';
import HourMaskMMHHSS from '../../../../components/Inputs/HourMaskMMHHSS.js';
import GasOrderNumberService from '../service/GasOrderNumberService';
import TelephoneMask from '../../../../components/Inputs/TelephoneMask';
import SimpleHeader from '../../../../components/Headers/SimpleHeader';
import ReactButton from '../../../../components/Buttons/ReactButton';
import DefaultModal from '../../../../components/Modal/DefaultModal';
import { TabContainer, TabWrapper } from './components/Tabs/style';
import FlexSelect from '../../../../components/Inputs/FlexSelect';
import { ErrorFormMessage } from './components/ErrorFormMessage';
import GasOrderService from '../service/GasOrderService';
import CustomDatePicker from './components/CustomDatePicker';
import { ClassInfoTable } from './components/ClassInfoTable';
import React, { useState, useEffect, useMemo } from 'react';
import { useGetSubReason } from '../hooks/useGetSubReason';
import { useLocation } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChatService from '../../../Conversation/service';
import { ErrorMessage } from '@hookform/error-message';
import AccountService from '../service/AccountService';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { ProductTable } from './tables/productTable';
import { useGetReason } from '../hooks/useGetReason';
import { useGetAreas } from '../hooks/useGetAreas';
import { useGetPhase } from '../hooks/useGetPhase';
import { useGetUser } from '../hooks/useGetUser';
import { Tabs } from './components/Tabs/index';
import AsyncSelect from 'react-select/async';
import { AddTab } from './components/AddTab';
import ReactLoader from 'components/Loader';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import io from 'socket.io-client';

import {
  HistoryContent,
  Infotable,
  CopyButtonWrapper,
  SelectText,
  FilialCodeWrapper
} from './styles';

import { Tr, Td, P } from './components/CheckProductAvailabilityModal/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@material-ui/core';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody,
  Table
} from 'reactstrap';

import {
  adicionar,
  remover,
  editarConta,
  editarCamposConta,
  editarCamposPedidoDeGas
} from '../../../../store/action/GasOrder/gasOrder';
import {
  maskPhoneNumber,
  removeMaskSpecialCharacters
} from 'views/CRM/shared/utils/phoneNumberHelpers';

const GasOrderList = (props) => {
  const { search } = useLocation();

  const { id } = props.match.params;

  const errorFormMessage = (message) => <ErrorFormMessage message={message} />;
  const { areaList } = useGetAreas();
  const { phaseList } = useGetPhase();
  const { reasonList } = useGetReason();
  const { subReasonList } = useGetSubReason();
  const { userList } = useGetUser();

  const { handleSubmit, control, setValue, errors, reset, getValues } =
    useForm();

  const [filial, setFilial] = useState('');
  const [hide, setHide] = useState();
  const [hidden, setHidden] = useState(true);
  const [control1, setControl1] = useState(true);
  const [control2, setControl2] = useState(true);
  const [control3, setControl3] = useState(true);
  const [control4, setControl4] = useState(true);
  const [control5, setControl5] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCifOpen, setIsModalCifOpen] = useState(false);
  const [modalInfo, setModalInfo] = useState(null);
  const [data, setData] = useState([]);
  const [opportunityNumber, setOpportunityNumber] = useState(null);
  const [conta, setConta] = useState({});
  const [socketAccountName, setSocketAccountName] = useState('Conta');
  const [isOpenedByChat, setIsOpenedByChat] = useState(false);
  const [opportunityId, setOpportunityId] = useState('');
  const [conversationId, setConversationId] = useState(null);
  const [isNewTab, setIsNewTab] = useState(false);
  const [hora, setHora] = useState('06:00:00');
  const [selectedOpportunity, setSelectedOpportunity] = useState(0);
  const dispatch = useDispatch();
  const gasOrders = useSelector((state) => state.gasOrderReducer);
  const [dataOportunidade, setDataOportunidade] = useState(
    new Date().toLocaleDateString('pt-br')
  );
  const [isSaving, setIsSaving] = useState(false);

  const minHeight = '';

  const socket = useMemo(
    () =>
      io.connect(process.env.REACT_APP_PROXY_URL, {
        path: process.env.REACT_APP_CRM_SOCKET_PATH,
        transports: ['websocket'],
        upgrade: false,
        extraHeaders: {
          authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }),
    []
  );

  const getOpportunityNumber = async () => {
    return GasOrderNumberService.getAll()
      .then((res) => {
        const number = res.data.data;
        return number;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getAccountList = async (input) => {
    let inputUpperCase = input.toUpperCase();
    return AccountService.getAccountByDocument(inputUpperCase)
      .then((res) => {
        let accountOptionsList = res.data.data.map((conta) => {
          if (conta.codigoEmpresa === '40278') {
            return {
              value: conta.id,
              label: `${conta.cpfCnpj}-${conta.nome}-${conta.filial}-NGD`
            };
          } else if (conta.codigoEmpresa === '43278') {
            return {
              value: conta.id,
              label: `${conta.cpfCnpj}-${conta.nome}-${conta.filial}-NGC`
            };
          }
        });
        return accountOptionsList;
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSingleAccount = async (
    id,
    shouldClear,
    telefone,
    isSocket = false,
    isFromGetOpportunity = false
  ) => {
    console.log('id: ', id);
    console.log('telefone: ', telefone);
    if (id !== '') {
      AccountService.get(id)
        .then(async (res) => {
          const oportunidade = res.data.data;
          console.log('res: ', oportunidade);
          const formatedData = {
            id: oportunidade.id,
            email: oportunidade.email,
            idTelegram: '',
            idFacebook: '',
            telefone: oportunidade.telefone,
            nome: oportunidade.nome,
            idWhatsapp: '',
            foiCriadoAutomaticamente: '',
            cpfCnpj: oportunidade.cpfCnpj,
            categoriaDaConta: oportunidade.categoriaDaConta,
            classe: oportunidade.classe ? oportunidade.classe : '',
            autorizacao: oportunidade.autorizacao,
            distribuidora: oportunidade.distribuidora,
            filial: oportunidade.filial,
            idEbs: oportunidade.idEbs,
            codigoEmpresa: oportunidade.codigoEmpresa,
            codigoRegional: oportunidade.codigoRegional,
            nomeRegional: oportunidade.nomeRegional,
            codigoFilial: oportunidade.codigoFilial,
            tipoCliente: oportunidade.tipoCliente,
            dataUltimaCompra: oportunidade.dataUltimaCompra,
            uf: oportunidade.uf,
            contraSenha: oportunidade.contraSenha,
            nomeEbs: oportunidade.nomeEbs ?? oportunidade.nomeEbs
          };
          if (res.data.data.nome !== 'email') {
            if (shouldClear) {
              resetFieldsCustom();
              setData([]);
            }
            if (isSocket && !isFromGetOpportunity) {
              const numero = await getOpportunityNumber();
              let newOp = {
                isUpdate: false,
                id:
                  Date.now().toString(36) +
                  Math.random().toString(36).substr(2),
                nomeOportunidade: res.data.data.nome,
                conta: formatedData,
                isOpen: true,
                OpportunityTelephone: telefone,
                telefone: maskPhoneNumber(telefone),
                produtos: [],
                numero
              };
              dispatch(adicionar(newOp));
            } else if (!isSocket && !isFromGetOpportunity) {
              if (gasOrders[selectedOpportunity]) {
                dispatch(
                  editarConta({
                    index: selectedOpportunity,
                    conta: formatedData
                  })
                );
              }
              const contaOportunidade = res.data.data;
              const oportunidadeAtual = gasOrders[selectedOpportunity];
              const isEmail =
                oportunidadeAtual?.motivoId ===
                '65f9600b-3ccb-4d54-a03c-1a2e95e043ce';

              const email = isEmail
                ? oportunidadeAtual.email ?? contaOportunidade.email ?? ''
                : contaOportunidade.email ?? '';
              const formatedConta = {
                ...contaOportunidade,
                telephone: contaOportunidade.telefone
                  ? contaOportunidade.telefone
                  : '',
                contraSenha: contaOportunidade.contraSenha,
                class: contaOportunidade.classe,
                autorization: contaOportunidade.autorizacao,
                distributor: contaOportunidade.distribuidora,
                accountCategory: contaOportunidade.categoriaDaConta,
                CNPJ: contaOportunidade.cpfCnpj,
                dateLastBuy: contaOportunidade.dataUltimaCompra
                  ? formatDate(contaOportunidade.dataUltimaCompra)
                  : '',
                Email: email,
                branch: handleAccountBranch(
                  contaOportunidade.filial,
                  contaOportunidade.codigoEmpresa
                ),
                branchCode: contaOportunidade.codigoFilial,
                nomeEbs:
                  contaOportunidade?.nomeEbs ?? contaOportunidade?.nome_ebs
              };

              reset({});
              reset(formatedConta);

              setDataOportunidade(new Date().toLocaleDateString('pt-br'));
              setFilial(res.data.data.codigoFilial);
              setConta(res.data.data);
              const codigoEmpresa =
                res?.data?.data?.codigoEmpresa ??
                res?.data?.data?.c_digo_empresa;
              setSocketAccountName({
                label: `${res.data.data['cpf_cnpj']}-${res.data.data.nome}-${
                  res.data.data.filial
                }-${codigoEmpresa === '40278' ? 'NGC' : 'NGD'}`
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getOpportunity = (id, telefone = '') => {
    console.log('id: ', id);
    console.log('telefone: ', telefone);
    if (id !== '') {
      GasOrderService.get(id)
        .then((res) => {
          console.log('res: ', res);
          res.data.data.produtos = res.data.data.produtos.map((produto) => {
            if (!produto.entrada) {
              produto.entrada = 0;
            }
            return produto;
          });
          let newOportunidade = {
            isUpdate: true,
            ...res.data.data,
            nomeOportunidade: res.data?.data?.conta?.nome,
            telefone: res.data?.data?.telefone
              ? maskPhoneNumber(res.data?.data?.telefone)
              : '',
            isOpen: true
          };
          if (telefone) {
            newOportunidade.telefone = telefone;
          }
          if (
            !newOportunidade.prioridade ||
            (newOportunidade.prioridade !== 'CIF' &&
              newOportunidade.prioridade !== 'FOB')
          ) {
            newOportunidade.prioridade = 'FOB';
          }
          if (!newOportunidade.submotivoId) {
            newOportunidade.submotivoId =
              '6b7782a7-5907-4963-a953-a59bc0ff3f2d';
          }

          dispatch(adicionar(newOportunidade));
          setCurrentOpportunity(newOportunidade);
        })
        .catch((err) => {
          console.log(err);
          toast.error('ocorreu um erro ao receber a oportunidade');
        });
    }
  };

  const setCurrentOpportunity = (oportunidade) => {
    if (oportunidade.isFormated) {
      setData(oportunidade.produtos);
    } else {
      let oportunidadeProdutos = oportunidade.produtos.map((info) => {
        return {
          amount: info.quantidade,
          discount: info.desconto ?? 0,
          ativo: info.produto.ativo,
          code: info.produto.codigo,
          criadoPor: info.produto.criadoPor,
          descricao: info.produto.descricao,
          id: info.produto.id,
          name: info.produto.nome,
          value: info.produto.preco,
          family: info.familiaId,
          measure: info.unidadeMedidaId,
          entrada: info.entrada
        };
      });
      setData(oportunidadeProdutos);
    }
    setOpportunityId(oportunidade.id);
    setOpportunityNumber(oportunidade.numero);
    setDataOportunidade(
      oportunidade.dataAgendamento
        ? toISOFormat(oportunidade.dataAgendamento)
        : new Date().toLocaleDateString('pt-br')
    );
    setHora(
      oportunidade.horaAgendamento ? oportunidade.horaAgendamento : '06:00:00'
    );
    const formatedOportunidade = {
      ...oportunidade,
      oportunnityPhase: oportunidade.faseId ? oportunidade.faseId : 7,
      paymantForm: oportunidade.formaDePagamento
        ? oportunidade.formaDePagamento
        : 'PRAZO',
      modality: oportunidade.prioridade ?? oportunidade.modalidade,
      opportunityProprietary: oportunidade.proprietarioId,
      description: oportunidade.descricao,
      clientCommunication: oportunidade.comunicacaoAoCliente,
      motive: oportunidade.motivoId,
      subMotive: oportunidade.submotivoId,
      externalProtocol: oportunidade.protocoloExterno,
      responsableArea: oportunidade.areaId,
      numberPayingDays: oportunidade.diasDePagamento,
      timeStart: oportunidade.horaAgendamento,
      OpportunityTelephone: oportunidade.telefone ? oportunidade.telefone : '',
      oportunnityNumber: oportunidade.numero
    };

    reset();
    reset(formatedOportunidade);

    if (oportunidade.conta && JSON.stringify(oportunidade.conta).length > 2) {
      setCurrentAccountByObject(formatedOportunidade, oportunidade.email);
    } else if (oportunidade.contaId) {
      getSingleAccount(oportunidade.contaId, false);
    } else {
      setConta({});
    }
  };

  const setCurrentAccountByObject = (oportunidade) => {
    const contaOportunidade = oportunidade.conta;

    const formatedOportunidade = {
      ...oportunidade,
      telephone: contaOportunidade.telefone ? contaOportunidade.telefone : '',
      contraSenha: contaOportunidade.contraSenha
        ? contaOportunidade.contraSenha
        : '',
      class: contaOportunidade.classe ? contaOportunidade.classe : '',
      autorization: contaOportunidade.autorizacao,
      distributor: contaOportunidade.distribuidora,
      accountCategory: contaOportunidade.categoriaDaConta,
      CNPJ: contaOportunidade.cpfCnpj,
      dateLastBuy: contaOportunidade.dataUltimaCompra
        ? formatDate(contaOportunidade.dataUltimaCompra)
        : '',
      Email: oportunidade.email
        ? oportunidade.email
        : oportunidade.conta.email
        ? oportunidade.conta.email
        : '',
      branch: handleAccountBranch(
        oportunidade.conta.filial,
        oportunidade.conta.codigoEmpresa
      ),
      branchCode: oportunidade.conta.codigoFilial,
      nomeEbs: oportunidade.conta.nomeEbs ?? oportunidade?.conta?.nome_ebs
    };

    reset();
    reset(formatedOportunidade);

    if (contaOportunidade.cpfCnpj) {
      setSocketAccountName({
        label: `${
          contaOportunidade['cpfCnpj']
            ? contaOportunidade['cpfCnpj']
            : contaOportunidade['cpfCnpj']
        }-${contaOportunidade.nome}-${contaOportunidade.filial}-${
          contaOportunidade.codigoEmpresa === '40278' ? 'NGC' : 'NGD'
        }`
      });
    }
    setConta(contaOportunidade);
    setFilial(contaOportunidade.codigoFilial);
  };

  async function addOpportunityToConversation(opportunity) {
    const conversationIdFromURL = conversationId;
    const conversationIdFromChatWindow =
      gasOrders[selectedOpportunity]?.idDaConversa;
    const convId = conversationIdFromURL || conversationIdFromChatWindow;

    if (convId) {
      const { id: oportunidadeId, motivoId, submotivoId, faseId } = opportunity;
      await ChatService.setOpportunity(convId, {
        oportunidadeId,
        motivoId,
        submotivoId,
        faseId
      });
    }
  }

  const onSubmit = (event) => {
    if (event.hasFob === false && event.hasCif === false) {
      return toast.error('Não há estoque nenhuma das modalidades', {
        autoClose: 3000,
        closeOnClick: true
      });
    }

    let formatedProductsToSend = data.map((product) => {
      return {
        produtoId: product.id,
        preco: product.value,
        desconto: product.discount ?? 0,
        quantidade: product.amount,
        entrada: product.entrada
      };
    });

    if (JSON.stringify(conta).length === 2) {
      return toast.error('Por favor selecione uma conta!', {
        autoClose: 3000,
        closeOnClick: true
      });
    }

    let formatedDataToSend = {
      // nome: event.oportunnityName ? event.oportunnityName : '',
      categoriaDaConta: event.accountCategory,
      dataDaUltimaCompra: event.dateLastBuy,
      dataAgendamento: formatData(event.dateEnd),
      filial: conta.filial,
      cpjCnpj: event.CNPJ,
      telefone: removeMaskSpecialCharacters(event.OpportunityTelephone || ''),
      modalidade: event.modalidadeValue,
      prioridade: event.modality,
      horaAgendamento: event.timeStart,
      numero: event.oportunnityNumber,
      descricao: event.description,
      faseId: event.oportunnityPhase,
      areaId: event.responsableArea,
      motivoId: event.motive,
      diasDePagamento: +event.numberPayingDays,
      submotivoId: event.subMotive,
      protocoloExterno: +event.externalProtocol,
      formaDePagamento: event.paymantForm,
      autorizacao: event.autorization,
      contraSenha: event.contraSenha ? `${event.contraSenha}` : null,
      classe: event.class,
      distribuidora: event.distributor,
      emailDaRegional: event.Email,
      email: event.Email,
      comunicacaoAoCliente: event.clientCommunication,
      proprietario: { login: event.opportunityProprietary },
      contaId: conta.id,
      produtos: formatedProductsToSend
    };

    setIsSaving(true);
    if (gasOrders[selectedOpportunity].isUpdate) {
      GasOrderService.put(opportunityId, formatedDataToSend)
        .then((res) => {
          const createdOpportunity = res.data.data;
          addOpportunityToConversation(createdOpportunity);

          toast.success('Oportunidade atualizada com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });

          if (isOpenedByChat) {
            setInterval(() => window.close(), 4000);
          } else if (isNewTab) {
            setInterval(() => window.close(), 2000);
          } else {
            clearAll();
            dispatch(remover(selectedOpportunity));
          }
        })
        .catch((err) => {
          if (err.response.data.errors[0].includes('insuficiente')) {
            let modalidade;
            if (!event.modalidadeValue) {
              modalidade = getValues('modality');
            } else {
              modalidade = event.modalidadeValue;
            }
            let answer = `Quantidade de ${modalidade} insuficiente. Deseja debitar a quantidade de estoque ${
              modalidade === 'FOB' ? 'CIF' : 'FOB'
            } ? `;

            setModalInfo(event);
            setIsModalCifOpen(true);
          } else {
            toast.error(
              err.response.data.errors[0] ||
                'Ocorreu um erro ao atualizar a oportunidade!',
              {
                autoClose: 3000,
                closeOnClick: true
              }
            );
          }
        })
        .finally(() => {
          setIsSaving(false);
        });
    } else {
      GasOrderService.post(formatedDataToSend)
        .then((res) => {
          const createdOpportunity = res.data.data;
          addOpportunityToConversation(createdOpportunity);
          toast.success('Oportunidade cadastrada com sucesso!', {
            autoClose: 3000,
            closeOnClick: true
          });
          clearAll();
          if (isOpenedByChat) {
            setInterval(() => window.close(), 4000);
          } else {
            clearAll();
            dispatch(remover(selectedOpportunity));
          }
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response.data.errors[0]);
          if (err.response.data.errors[0].includes('insuficiente')) {
            let modalidade;
            if (!event.modalidadeValue) {
              modalidade = getValues('modality');
            } else {
              modalidade = event.modalidadeValue;
            }
            let answer = `Quantidade de ${modalidade} insuficiente. Deseja debitar a quantidade de estoque ${
              modalidade === 'FOB' ? 'CIF' : 'FOB'
            } ? `;
            if (modalidade === 'FOB') {
              event = { ...event, hasFob: false };
            } else {
              event = { ...event, hasCif: false };
            }

            setModalInfo(event);
            setIsModalCifOpen(true);
          } else {
            toast.error(
              err.response.data.errors[0] ||
                'Ocorreu um erro ao cadastrar a oportunidade!',
              {
                autoClose: 3000,
                closeOnClick: true
              }
            );
          }
        })
        .finally(() => {
          setIsSaving(false);
        });
    }
  };

  const resetFieldsCustom = () => {
    const camposValores = {
      oportunnityPhase: 7,
      paymantForm: 'PRAZO',
      modality: 'FOB',
      opportunityProprietary: `${localStorage.getItem('login')}`,
      clientCommunication: '',
      motive: '01891cf3-4d2a-4983-85ce-6b4697eb3efc',
      subMotive: '6b7782a7-5907-4963-a953-a59bc0ff3f2d',
      externalProtocol: '',
      responsableArea: 7,
      numberPayingDays: '',
      timeStart: '06:00:00',
      OpportunityTelephone: '',
      contraSenha: '',
      Email: '',
      telephone: '',
      class: '',
      autorization: '',
      distributor: '',
      branch: '',
      accountCategory: '',
      CNPJ: '',
      dateLastBuy: '',
      description: ''
    };

    reset(camposValores);
  };

  const clearAll = (shouldClearAll = true) => {
    if (shouldClearAll) {
      reset();
    } else {
      resetFieldsCustom();
    }
    setData([]);
    setDataOportunidade(new Date().toLocaleDateString('pt-br'));
    setConta({});
    setSocketAccountName({});
    setFilial('');
  };

  useEffect(() => {
    if (gasOrders && gasOrders.length === 0 && !isNewTab) {
      adicionarNovaOportunidade();

      return;
    }

    if (gasOrders && gasOrders.length > 0) {
      clearAll();
      let index = gasOrders.length - 1;
      setSelectedOpportunity(index);
      setCurrentOpportunity(gasOrders[index]);
    }
  }, [gasOrders.length]);

  useEffect(() => {
    const { accountid, openedByChat, conversationId } =
      queryString.parse(search);

    if (id) {
      if (!gasOrders.find((oportunidade) => oportunidade.id === id)) {
        getOpportunity(id);
        if (gasOrders && gasOrders.length >= 1) {
          setSelectedOpportunity(selectedOpportunity + 1);
        }
      } else {
        const index = gasOrders.findIndex((oportunidade) => {
          return oportunidade.id === id;
        });
        setSelectedOpportunity(index);
        setCurrentOpportunity(gasOrders[index]);
      }
    }

    if (openedByChat) setIsOpenedByChat(true);
    if (accountid) getSingleAccount(accountid, false);
    if (conversationId) setConversationId(conversationId);

    const urlParameters = new URLSearchParams(window.location.search);
    const isNewTabOpen = urlParameters.get('isNewTab');
    setIsNewTab(isNewTabOpen === 'true');
  }, [id, search]);

  useEffect(() => {
    socket.on('crm:abrir_oportunidade', (eventData) => {
      console.log('eventData: ', eventData);
      if (eventData.codAgente === localStorage.getItem('agent_code')) {
        if (eventData['contaId']) {
          console.log('buscar conta');
          reset();
          setData([]);
          setValue('OpportunityTelephone', maskPhoneNumber(eventData.telefone));
          getSingleAccount(
            eventData['contaId'],
            true,
            eventData.telefone,
            true,
            false
          );
        } else {
          console.log('buscar oportunidade');
          getOpportunity(
            eventData['oportunidadeId'],
            maskPhoneNumber(eventData.telefone)
          );
        }
      }
    });

    return () => {
      socket.off();
    };
  }, [reset, setValue, socket]);

  useEffect(() => {
    setValue('dateEnd', dataOportunidade);
    setValue('timeStart', hora);
  }, [hora, dataOportunidade, setValue]);

  const formatDate = (data) => {
    if (data) {
      let newData = new Date(data);
      let formatedData = new Intl.DateTimeFormat('pt-BR', {
        timeZone: 'UTC'
      }).format(newData);

      return formatedData;
    }
  };

  const onError = () => {
    toast.error('Preencha os campos obrigatórios!', {
      autoClose: 3000,
      closeOnClick: true
    });
  };

  function handleAccountBranch(contaFilial, contaC_digo_empresa) {
    if (JSON.stringify(conta).length > 0 && contaFilial !== undefined) {
      if (contaC_digo_empresa === '40278') {
        return `${contaFilial}-NGD`;
      } else if (contaC_digo_empresa === '43278') {
        return `${contaFilial}-NGC`;
      }
    } else {
      return '';
    }
  }

  const formatData = (data) => {
    let splitData = data.split('/');
    let YY = splitData[2];
    let MM = splitData[1];
    let DD = splitData[0];
    let newDataEstoque = `${YY}-${MM}-${DD}`;
    return newDataEstoque;
  };

  const adicionarNovaOportunidade = async () => {
    const numero = await getOpportunityNumber();
    const newOpportunity = {
      nomeOportunidade: `Nova oportunidade`,
      id: Date.now().toString(36) + Math.random().toString(36).substr(2),
      isOpen: true,
      numero: numero,
      produtos: [],
      isUpdate: false,
      conta: {}
    };
    dispatch(adicionar(newOpportunity));
    return newOpportunity;
  };

  const stringToIso = (value) => {
    try {
      const stringArray = value.split('/');
      const DD = stringArray[0];
      const MM = stringArray[1];
      const YY = stringArray[2];
      let dateStr = `${YY}-${MM}-${DD}`;
      const date = new Date(dateStr);
      const iso = date.toISOString();
      return iso;
    } catch (e) {
      return value;
    }
  };

  const toISOFormat = (dataToFormat) => {
    const [date] = dataToFormat.split('T');
    const [YYYY, MM, DD] = date.split('-');

    let x = `${DD}/${MM}/${YYYY}`;

    return x;
  };

  const isOpportunityUpdate = () => {
    if (gasOrders[selectedOpportunity]) {
      return gasOrders[selectedOpportunity].isUpdate;
    }
  };

  const getDescriptionHistory = () => {
    if (gasOrders[selectedOpportunity]) {
      let historyStrings =
        gasOrders[selectedOpportunity].historicoDescricao.split('---');
      return historyStrings;
    }
  };

  const getClientCommunicationHistory = () => {
    if (gasOrders[selectedOpportunity]) {
      if (gasOrders[selectedOpportunity].historicoComunicacaoAoCliente) {
        let historyStrings =
          gasOrders[selectedOpportunity].historicoComunicacaoAoCliente.split(
            '---'
          );
        return historyStrings.map((valor) => {
          return valor;
        });
      }
    }
  };

  const getHistoryDetails = () => {
    if (gasOrders[selectedOpportunity]) {
      const historyResponsable = [...gasOrders[selectedOpportunity].historico];
      return historyResponsable.map((valor) => {
        valor.dataFormatada = Intl.DateTimeFormat('pt-br', {
          dateStyle: 'short',
          timeStyle: 'medium',
          hour12: false
        }).format(new Date(valor.data));
        return { ...valor };
      });
    }
  };

  const getText = () => {
    if (!modalInfo) return <></>;
    let modalidade;
    if (!modalInfo?.modalidadeValue) {
      modalidade = getValues('modality');
    } else {
      modalidade = modalInfo?.modalidadeValue;
    }

    let answer = `Quantidade de ${modalidade}
  insuficiente. Deseja debitar a quantidade de estoque
  ${modalidade === 'FOB' ? 'CIF' : 'FOB'} ? `;

    return <h3>{answer}</h3>;
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/dashboard"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Oportunidade</h3>
                </CardHeader>

                <CardBody style={{ padding: '0 1.5rem 1.5rem 1.5rem' }}>
                  {!isNewTab && (
                    <TabWrapper>
                      <TabContainer>
                        {gasOrders && gasOrders.length > 0
                          ? gasOrders.map((obj, index) => {
                              return (
                                <Tabs
                                  isSelect={index === selectedOpportunity}
                                  key={index}
                                  isOpen={obj.isOpen}
                                  text={obj.nomeOportunidade}
                                  onClick={() => {
                                    clearAll();
                                    setSelectedOpportunity(index);
                                    setCurrentOpportunity(gasOrders[index]);
                                  }}
                                  onClose={() => {
                                    dispatch(remover(index));
                                  }}
                                />
                              );
                            })
                          : null}
                        <AddTab
                          onClick={() => {
                            adicionarNovaOportunidade();
                          }}
                        />
                      </TabContainer>
                      <div className="tabLine"></div>
                    </TabWrapper>
                  )}

                  <Form
                    style={{
                      marginTop: '-1px',
                      padding: '0.5rem'
                    }}
                    onSubmit={handleSubmit(onSubmit, onError)}
                  >
                    {isOpportunityUpdate() && (
                      <Accordion
                        expanded={control5}
                        onChange={() => setControl5(!control5)}
                        className="accodion"
                        style={{ boxShadow: 'none', borderBottom: 'none' }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ borderBottom: '1px solid #dcdcdc' }}
                        >
                          <strong>Histórico de atualizações</strong>
                        </AccordionSummary>
                        <AccordionDetails
                          style={{
                            flexDirection: 'column'
                          }}
                        >
                          <Row className="mb-3">
                            <Col md="12" style={{ overflowX: 'auto' }}>
                              <Table>
                                <thead>
                                  <Tr>
                                    {[
                                      'DESCRIÇÃO:',
                                      'COMUNICAÇÃO AO CLIENTE:',
                                      'ALTERADO POR:',
                                      'DATA DA ALTERAÇÃO:'
                                    ].map((column, index) => (
                                      <th
                                        style={{
                                          whiteSpace: 'initial',
                                          textAlign: 'center',
                                          position: 'sticky',
                                          top: '0',
                                          fontWeight: 'bold',
                                          // padding: '1rem',
                                          backgroundColor: '#f6f9fc'
                                        }}
                                        key={index}
                                      >
                                        {column}
                                      </th>
                                    ))}
                                  </Tr>
                                </thead>
                                <tbody>
                                  {getDescriptionHistory()
                                    ? getDescriptionHistory().map(
                                        (valor, index) => {
                                          return (
                                            <Tr
                                              key={index}
                                              style={{
                                                width: '100%',
                                                textAlign: 'initial',
                                                border: '1px solid #dee2e6'
                                              }}
                                            >
                                              <Td
                                                style={{
                                                  padding: '0',
                                                  borderLeft:
                                                    '1px solid #dee2e6',
                                                  borderRight:
                                                    '1px solid #dee2e6'
                                                }}
                                              >
                                                <HistoryContent>
                                                  <P
                                                    style={{
                                                      padding: '0 0.3rem',
                                                      margin: '0',
                                                      width: '100%',
                                                      maxWidth: '32rem'
                                                    }}
                                                  >
                                                    {valor}
                                                  </P>
                                                </HistoryContent>
                                              </Td>

                                              <Td
                                                style={{
                                                  padding: '0',
                                                  borderLeft:
                                                    '1px solid #dee2e6',
                                                  borderRight:
                                                    '1px solid #dee2e6'
                                                }}
                                              >
                                                <HistoryContent>
                                                  <P
                                                    style={{
                                                      padding: '0 0.3rem',
                                                      margin: '0',
                                                      width: '100%',
                                                      maxWidth: '32rem'
                                                    }}
                                                  >
                                                    {getClientCommunicationHistory()
                                                      ? getClientCommunicationHistory()[
                                                          index
                                                        ]
                                                      : ''}
                                                  </P>
                                                </HistoryContent>
                                              </Td>

                                              <Td
                                                style={{
                                                  padding: '0',
                                                  borderLeft:
                                                    '1px solid #dee2e6',
                                                  borderRight:
                                                    '1px solid #dee2e6'
                                                }}
                                              >
                                                <HistoryContent>
                                                  <P
                                                    style={{
                                                      padding: '0 0.3rem',
                                                      margin: '0',
                                                      width: '100%',
                                                      maxWidth: '32rem'
                                                    }}
                                                  >
                                                    {getHistoryDetails()[index]
                                                      ? getHistoryDetails()[
                                                          index
                                                        ].usuario.name
                                                      : ''}
                                                  </P>
                                                </HistoryContent>
                                              </Td>

                                              <Td
                                                style={{
                                                  padding: '0',
                                                  borderLeft:
                                                    '1px solid #dee2e6',
                                                  borderRight:
                                                    '1px solid #dee2e6'
                                                }}
                                              >
                                                <HistoryContent>
                                                  <P
                                                    style={{
                                                      padding: '0 0.3rem',
                                                      margin: '0',
                                                      width: '100%',
                                                      maxWidth: '32rem'
                                                    }}
                                                  >
                                                    {getHistoryDetails()[index]
                                                      ? getHistoryDetails()[
                                                          index
                                                        ].dataFormatada
                                                      : ''}
                                                  </P>
                                                </HistoryContent>
                                              </Td>
                                            </Tr>
                                          );
                                        }
                                      )
                                    : null}
                                </tbody>
                              </Table>
                            </Col>
                          </Row>
                        </AccordionDetails>
                      </Accordion>
                    )}

                    {/* Informações da conta */}
                    <Accordion
                      expanded={control2}
                      onChange={() => setControl2(!control2)}
                      className="accodion"
                      style={{ boxShadow: 'none', borderBottom: 'none' }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{ borderBottom: '1px solid #dcdcdc' }}
                      >
                        <strong>Informações da conta</strong>
                      </AccordionSummary>
                      <AccordionDetails style={{ flexDirection: 'column' }}>
                        <Row className="mb-3">
                          <Col md="6" style={{ position: 'relative' }}>
                            <label className="form-control-label">Conta</label>
                            <SelectText hide={hide}>
                              {socketAccountName.label}
                            </SelectText>
                            <Controller
                              render={() => (
                                <AsyncSelect
                                  placeholder={'conta'}
                                  cacheOptions
                                  onInputChange={setHide}
                                  value={socketAccountName}
                                  isClearable
                                  styles={getFlexSelectCustomStyle({
                                    minHeight
                                  })}
                                  onChange={(e) => {
                                    if (e === null) {
                                      clearAll(false);
                                    } else {
                                      getSingleAccount(e.value, true);
                                    }
                                  }}
                                  loadOptions={getAccountList}
                                />
                              )}
                              control={control}
                              name="account"
                              fieldName="account"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">Email </label>
                            <Controller
                              render={(props) => (
                                <Input
                                  value={props.value}
                                  onChange={(e) => {
                                    props.onChange(e);
                                    dispatch(
                                      editarCamposConta({
                                        index: selectedOpportunity,
                                        value: e.target.value,
                                        field: 'email'
                                      })
                                    );
                                  }}
                                  inputRef={props.ref}
                                />
                              )}
                              name="Email"
                              defaultValue={''}
                              control={control}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Telefone{' '}
                            </label>
                            <Controller
                              render={(props) => (
                                <TelephoneMask
                                  valueController={setValue}
                                  disabled={true}
                                  fieldName="telephone"
                                  value={props.value}
                                  placeholder="(88)8.9999-9999"
                                  defaultValue={
                                    JSON.stringify(conta).length > 0 &&
                                    conta.telefone !== undefined
                                      ? conta.telefone
                                      : ''
                                  }
                                />
                              )}
                              control={control}
                              name="telephone"
                              onChange={(e) => {
                                const newConta = { ...conta };
                                newConta.telefone = e.target.value;
                                setConta(newConta);
                              }}
                              defaultValue={
                                JSON.stringify(conta).length > 0 &&
                                conta.telefone !== undefined
                                  ? conta.telefone
                                  : ''
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Contra Senha
                            </label>
                            <Controller
                              render={(props) => (
                                <Input
                                  type={'number'}
                                  value={props.value}
                                  onChange={(e) => {
                                    props.onChange(e);
                                    dispatch(
                                      editarCamposConta({
                                        index: selectedOpportunity,
                                        value: e.target.value,
                                        field: 'contraSenha'
                                      })
                                    );
                                  }}
                                  inputRef={props.ref}
                                />
                              )}
                              name="contraSenha"
                              defaultValue={''}
                              control={control}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6" style={{ position: 'relative' }}>
                            <label className="form-control-label">
                              Classe{' '}
                            </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="class"
                              defaultValue=""
                            />
                            <Infotable>
                              <li
                                style={{ cursor: 'pointer' }}
                                className="fas fa-info-circle"
                                onMouseOver={(event) => {
                                  setHidden(false);
                                }}
                              ></li>
                            </Infotable>
                            <ClassInfoTable
                              hidden={hidden}
                              setHidden={setHidden}
                            />
                          </Col>{' '}
                          <Col md="6">
                            <label className="form-control-label">
                              Autorização{' '}
                            </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="autorization"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Distribuidora{' '}
                            </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="distributor"
                              defaultValue=""
                            />
                          </Col>{' '}
                          <Col md="6">
                            <label className="form-control-label">
                              Filial{' '}
                            </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="branch"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Categoria da Conta
                            </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="accountCategory"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Código da Filial{' '}
                            </label>
                            <FilialCodeWrapper>
                              <Controller
                                as={<Input style={{ fontWeight: 'bold' }} />}
                                disabled
                                id="codigoFilial"
                                control={control}
                                name="branchCode"
                                defaultValue=""
                              />
                              <CopyButtonWrapper title="Copiar texto">
                                <button
                                  onClick={() => {
                                    let text =
                                      document.getElementById('codigoFilial');
                                    text.select();
                                    text.setSelectionRange(0, 99999);
                                    if (text.value) {
                                      navigator.clipboard.writeText(text.value);

                                      toast.info(
                                        'Texto Copiado: ' + text.value
                                      );
                                    }
                                  }}
                                  type="button"
                                >
                                  <li className="fas fa-copy"></li>
                                </button>
                              </CopyButtonWrapper>
                            </FilialCodeWrapper>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Data da Última Compra
                            </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="dateLastBuy"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Identificação filial{' '}
                            </label>
                            <FilialCodeWrapper>
                              <Controller
                                as={<Input style={{ fontWeight: 'bold' }} />}
                                disabled
                                id="identFilial"
                                control={control}
                                name="nomeEbs"
                                defaultValue=""
                              />
                              <CopyButtonWrapper title="Copiar texto">
                                <button
                                  onClick={() => {
                                    let text =
                                      document.getElementById('identFilial');
                                    text.select();
                                    text.setSelectionRange(0, 99999);
                                    if (text.value) {
                                      navigator.clipboard.writeText(text.value);

                                      toast.info(
                                        'Texto Copiado: ' + text.value
                                      );
                                    }
                                  }}
                                  type="button"
                                >
                                  <li className="fas fa-copy"></li>
                                </button>
                              </CopyButtonWrapper>
                            </FilialCodeWrapper>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">CNPJ </label>
                            <Controller
                              as={<Input style={{ fontWeight: 'bold' }} />}
                              disabled
                              control={control}
                              name="CNPJ"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Número da Oportunidade{' '}
                            </label>
                            <FilialCodeWrapper>
                              <Controller
                                render={() => (
                                  <Input
                                    style={{ fontWeight: 'bold' }}
                                    defaultValue={opportunityNumber}
                                    disabled={true}
                                  />
                                )}
                                control={control}
                                name="oportunnityNumber"
                                fieldname="oportunnityNumber"
                                id="oportunnityNumberInput"
                                defaultValue={opportunityNumber}
                              />
                              <CopyButtonWrapper title="Copiar texto">
                                <button
                                  onClick={() => {
                                    let text = document.getElementById(
                                      'oportunnityNumberInput'
                                    );
                                    text.select();
                                    text.setSelectionRange(0, 99999);
                                    if (text.value) {
                                      navigator.clipboard.writeText(text.value);
                                      toast.info(
                                        'Texto Copiado: ' + text.value
                                      );
                                    }
                                  }}
                                  type="button"
                                >
                                  <li className="fas fa-copy"></li>
                                </button>
                              </CopyButtonWrapper>
                            </FilialCodeWrapper>
                          </Col>
                        </Row>
                      </AccordionDetails>
                    </Accordion>

                    {/* Informa1ções da conta */}

                    {/* Informações de oportunidade */}
                    <Accordion
                      expanded={control1}
                      onChange={() => setControl1(!control1)}
                      className="accodion"
                      style={{ boxShadow: 'none', borderBottom: 'none' }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{ borderBottom: '1px solid #dcdcdc' }}
                      >
                        <strong>Campos de oportunidade</strong>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          flexDirection: 'column'
                        }}
                      >
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Forma de pagamento*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={[
                                    {
                                      label: 'A VISTA',
                                      paymantForm: 'A VISTA'
                                    },
                                    {
                                      label: 'PRAZO',
                                      paymantForm: 'PRAZO'
                                    }
                                  ]}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'formaDePagamento',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="paymantForm"
                                  labelName="label"
                                  valueName="paymantForm"
                                  defaultValue="PRAZO"
                                />
                              )}
                              rules={{
                                required: 'A forma de pagamento é obrigatória!'
                              }}
                              control={control}
                              name="paymantForm"
                              fieldName="paymantForm"
                              defaultValue="PRAZO"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="paymantForm"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Data de Agendamento
                            </label>
                            <Controller
                              render={(props) => (
                                <CustomDatePicker
                                  fieldName="dateEnd"
                                  valueController={(fieldName, value) => {
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'dataAgendamento',
                                        value: stringToIso(value),
                                        index: selectedOpportunity
                                      })
                                    );
                                    setDataOportunidade(value);
                                  }}
                                  defaultValue={props.value}
                                />
                              )}
                              rules={{
                                required: 'A Data de Fechamento é obrigatória!',
                                pattern: {
                                  value:
                                    /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
                                  message: 'Data inválida! (dd/MM/aaaa)'
                                }
                              }}
                              control={control}
                              name="dateEnd"
                              fieldName="dateEnd"
                              defaultValue={
                                dataOportunidade
                                  ? dataOportunidade
                                  : new Date().toLocaleDateString('pt-br')
                              }
                            />
                            <ErrorMessage
                              errors={errors}
                              name="dateEnd"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Fase da Oportunidade*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={phaseList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'faseId',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="oportunnityPhase"
                                  labelName="label"
                                  valueName="oportunnityPhase"
                                />
                              )}
                              control={control}
                              name="oportunnityPhase"
                              fieldName="oportunnityPhase"
                              defaultValue={7}
                              rules={{
                                required:
                                  'A Fase da Oportunidade é obrigatória!'
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="oportunnityPhase"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Hora do Agendamento
                            </label>
                            <Controller
                              render={(props) => (
                                <HourMaskMMHHSS
                                  valueController={(fieldName, value) => {
                                    setHora(value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'horaAgendamento',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  fieldName="timeStart"
                                  value={props.value}
                                />
                              )}
                              rules={{
                                required:
                                  'A Hora de Agendamento é obrigatória!',
                                pattern: {
                                  value: /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
                                  message: 'Hora inválida!'
                                }
                              }}
                              control={control}
                              name="timeStart"
                              fieldName="timeStart"
                              defaultValue="06:00:00"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="timeStart"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Modalidade*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={[
                                    {
                                      label: 'CIF',
                                      modality: 'CIF'
                                    },
                                    {
                                      label: 'FOB',
                                      modality: 'FOB'
                                    }
                                  ]}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'modalidade',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="modality"
                                  labelName="label"
                                  valueName="modality"
                                  isDisabled={false}
                                />
                              )}
                              rules={{
                                required: 'A Modalidade é obrigatória!'
                              }}
                              control={control}
                              name="modality"
                              fieldName="modality"
                              defaultValue="FOB"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="modality"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Proprietário da Oportunidade
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={userList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'proprietarioId',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="opportunityProprietary"
                                  labelName="label"
                                  valueName="opportunityProprietary"
                                />
                              )}
                              rules={{
                                required: 'O Proprietário é obrigatório!'
                              }}
                              control={control}
                              name="opportunityProprietary"
                              fieldName="opportunityProprietary"
                              defaultValue={`${localStorage.getItem('login')}`}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="opportunityProprietary"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Motivo*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={(reasonList || []).sort(
                                    (a, b) => {
                                      if (a?.label < b?.label) return -1;
                                      if (a?.label > b?.label) return 1;
                                      return 0;
                                    }
                                  )}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'motivoId',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                    if (
                                      value ===
                                      '01891cf3-4d2a-4983-85ce-6b4697eb3efc'
                                    ) {
                                      let newData = data.filter(
                                        (produto) => produto.code !== 'granel'
                                      );
                                      setData(newData);
                                    } else if (
                                      value ===
                                      '0e02e514-e03d-41eb-be96-9434ce889885'
                                    ) {
                                      let newData = data.filter(
                                        (produto) => produto.code === 'granel'
                                      );
                                      setData(newData);
                                    }
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="motive"
                                  labelName="label"
                                  valueName="motive"
                                />
                              )}
                              rules={{ required: 'O Motivo é obrigatório!' }}
                              control={control}
                              name="motive"
                              fieldName="motive"
                              defaultValue="01891cf3-4d2a-4983-85ce-6b4697eb3efc"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="motive"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Sub Motivo*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={(subReasonList || []).sort(
                                    (a, b) => {
                                      if (a?.label < b?.label) return -1;
                                      if (a?.label > b?.label) return 1;
                                      return 0;
                                    }
                                  )}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'submotivoId',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="subMotive"
                                  labelName="label"
                                  valueName="subMotive"
                                />
                              )}
                              rules={{
                                required: 'O Sub motivo é obrigatório!'
                              }}
                              control={control}
                              name="subMotive"
                              defaultValue="6b7782a7-5907-4963-a953-a59bc0ff3f2d"
                              fieldName="subMotive"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="subMotive"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Telefone da Oportunidade{' '}
                            </label>

                            <Controller
                              render={(props) => (
                                <TelephoneMask
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'telefone',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  fieldName="OpportunityTelephone"
                                  value={props.value}
                                  placeholder="(99) 99999-9999"
                                  defaultValue={''}
                                  inputRef={props.ref}
                                />
                              )}
                              control={control}
                              name="OpportunityTelephone"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                      </AccordionDetails>
                    </Accordion>

                    {/* Informações de oportunidade */}

                    {/* Produtos */}
                    <Accordion
                      expanded={control4}
                      onChange={() => setControl4(!control4)}
                      className="accodion"
                      style={{
                        boxShadow: 'none',
                        paddingBottom: '0.5rem',
                        borderBottom: 'none'
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{ borderBottom: '1px solid #dcdcdc' }}
                      >
                        <strong>Produtos</strong>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{ flexDirection: 'column', overflow: 'auto' }}
                      >
                        <DefaultModal
                          show={isModalOpen}
                          onModalToggle={setIsModalOpen}
                          title="Adicionar Produto"
                          showCloseButton={false}
                          modalContainerClasses=""
                          style={{ width: '60%', maxWidth: '80rem' }}
                        >
                          <AddProductModalContent
                            data={data}
                            setData={setData}
                            isModalOpen={isModalOpen}
                            setIsModalOpen={setIsModalOpen}
                            filial={filial}
                            hora={hora}
                            setHora={setHora}
                            dataOportunidade={dataOportunidade}
                            setDataOportunidade={setDataOportunidade}
                            motivo={getValues('motive')}
                            selectedOpportunity={selectedOpportunity}
                          ></AddProductModalContent>
                        </DefaultModal>

                        <DefaultModal
                          show={isModalCifOpen}
                          onModalToggle={(value) => {
                            if (!value) {
                              setModalInfo(null);
                            }
                            setIsModalCifOpen(value);
                          }}
                          title="Confirmação"
                          showCloseButton={false}
                          modalContainerClasses="modal-sm"
                          style={{ width: '60%', maxWidth: '35rem' }}
                        >
                          <>
                            {getText()}

                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end'
                              }}
                            >
                              <ReactButton
                                onClick={() => {
                                  if (!modalInfo) return;
                                  let modalidade;
                                  if (!modalInfo?.modalidadeValue) {
                                    modalidade = getValues('modality');
                                  } else {
                                    modalidade = modalInfo?.modalidadeValue;
                                  }
                                  let copy = { ...modalInfo };
                                  if (modalidade === 'FOB') {
                                    copy = { ...modalInfo, hasFob: false };
                                  } else {
                                    copy = { ...modalInfo, hasCif: false };
                                  }
                                  setIsModalCifOpen(false);
                                  setModalInfo(null);
                                  onSubmit({
                                    ...copy,
                                    modalidadeValue:
                                      modalidade === 'FOB' ? 'CIF' : 'FOB'
                                  });
                                }}
                                btnColor="confirmation"
                                type="submit"
                              >
                                Confirmar
                              </ReactButton>
                              <ReactButton
                                btnColor="cancelation"
                                onClick={() => {
                                  setIsModalCifOpen(false);
                                  setModalInfo(null);
                                }}
                              >
                                Cancelar
                              </ReactButton>
                            </div>
                          </>
                        </DefaultModal>

                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            padding: '1rem 0',
                            marginRight: '-1rem'
                          }}
                        >
                          <ReactButton
                            btnColor="confirmation"
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                            disabled={filial === '' ? true : false}
                          >
                            Adicionar
                          </ReactButton>
                        </div>
                        <ProductTable
                          data={data}
                          setData={setData}
                          dispatch={dispatch}
                          selectedOpportunity={selectedOpportunity}
                        ></ProductTable>
                      </AccordionDetails>
                    </Accordion>
                    {/* Produtos */}

                    {/* Campos Customizados de Oportunidade */}
                    <Accordion
                      expanded={control3}
                      onChange={() => setControl3(!control3)}
                      className="accodion"
                      style={{ boxShadow: 'none', borderBottom: 'none' }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        style={{ borderBottom: '1px solid #dcdcdc' }}
                      >
                        <strong>Campos Adicionais de Oportunidade</strong>
                      </AccordionSummary>
                      <AccordionDetails style={{ flexDirection: 'column' }}>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Protocolo Externo{' '}
                            </label>
                            <Controller
                              render={(props) => (
                                <Input
                                  style={{ fontWeight: 'bold' }}
                                  value={props.value}
                                  onChange={(e) => {
                                    props.onChange(e);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'protocoloExterno',
                                        value: e.target.value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  inputRef={props.ref}
                                />
                              )}
                              name="externalProtocol"
                              fieldName="externalProtocol"
                              defaultValue={''}
                              control={control}
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Área Responsável*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={areaList}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={(fieldName, value) => {
                                    setValue(fieldName, value);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'areaId',
                                        value: value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="responsableArea"
                                  labelName="label"
                                  valueName="responsableArea"
                                />
                              )}
                              rules={{ required: 'A Área é obrigatória!' }}
                              control={control}
                              name="responsableArea"
                              fieldName="responsableArea"
                              defaultValue={7}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="responsableArea"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Descrição
                            </label>
                            <Controller
                              render={(props) => (
                                <Input
                                  value={props.value}
                                  onChange={(e) => {
                                    props.onChange(e);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'descricao',
                                        value: e.target.value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  inputRef={props.ref}
                                  type="textarea"
                                  rows="6"
                                />
                              )}
                              control={control}
                              name="description"
                              fieldName="description"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Comunicação ao Cliente
                            </label>

                            <Controller
                              render={(props) => (
                                <Input
                                  value={props.value}
                                  onChange={(e) => {
                                    props.onChange(e);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'comunicacaoAoCliente',
                                        value: e.target.value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  inputRef={props.ref}
                                  type="textarea"
                                  rows="6"
                                />
                              )}
                              control={control}
                              name="clientCommunication"
                              fieldName="clientCommunication"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Quantidade de dias de pagamento{' '}
                            </label>
                            <Controller
                              render={(props) => (
                                <Input
                                  value={props.value}
                                  onChange={(e) => {
                                    props.onChange(e);
                                    dispatch(
                                      editarCamposPedidoDeGas({
                                        field: 'diasDePagamento',
                                        value: e.target.value,
                                        index: selectedOpportunity
                                      })
                                    );
                                  }}
                                  inputRef={props.ref}
                                />
                              )}
                              name="numberPayingDays"
                              fieldName="numberPayingDays"
                              defaultValue={''}
                              control={control}
                            />
                          </Col>
                        </Row>
                      </AccordionDetails>
                    </Accordion>

                    {/* Campos Customizados de Oportunidade */}

                    <div
                      style={{
                        display: 'flex',
                        height: '2.6875rem'
                      }}
                    >
                      {isSaving ? (
                        <ReactLoader height={50} />
                      ) : (
                        <ReactButton btnColor="confirmation" type="submit">
                          Salvar
                        </ReactButton>
                      )}

                      {!isOpenedByChat && !isNewTab && !isSaving && (
                        <ReactButton
                          btnColor="cancelation"
                          onClick={() => {
                            dispatch(remover(selectedOpportunity));
                            window.scrollTo(0, 0);
                          }}
                        >
                          Cancelar
                        </ReactButton>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default GasOrderList;
